import { render, staticRenderFns } from "./sm-pagination.vue?vue&type=template&id=6ececa0c&"
import script from "./sm-pagination.vue?vue&type=script&lang=js&"
export * from "./sm-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports